module.exports = new __parcel__URL__("33376_sq.eb722cbc.jpg").toString();